import React, { memo } from 'react';
import { Typography } from '../../../../components';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { MISSING_CORRUPT_ERRORS } from '../../../../constants/discovery';

const { Title, Paragraph } = Typography;

export const InvalidFileError = memo(() => {
    return (
        <>
            <Title level={2}>Invalid file type</Title>
            <Paragraph>The uploaded file appears to be invalid or corrupted.</Paragraph>
        </>
    );
});

export const MissingOrCorruptFilesError = memo(({ missingFiles, fileType }) => {
    const { title, body, requiredFiles } = MISSING_CORRUPT_ERRORS[fileType];
    return (
        <>
            <Title level={2}>{title}</Title>
            <Paragraph>{body}</Paragraph>
            <ul className="required-files">
                {requiredFiles.map((file, index) => {
                    if (missingFiles.includes(file)) {
                        return (
                            <li className="missing" key={index}>
                                <ExclamationCircleOutlined /> {file}
                            </li>
                        );
                    } else {
                        return (
                            <li key={index}>
                                <CheckCircleOutlined style={{ color: 'var(--green-default)' }} /> {file}
                            </li>
                        );
                    }
                })}
            </ul>
        </>
    );
});

export const UncompressedSizeError = memo(({ maxSize }) => {
    return (
        <>
            <Title level={2}>Uncompressed file size error</Title>
            <Paragraph>
                The uncompressed contents of the ZIP file exceed the maximum allowed size of {maxSize} MB.
            </Paragraph>
        </>
    );
});
